// External Dependencies
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Internal Dependencies
import {
  BackToButton,
  EnhancedCard,
  Subtitle,
} from 'components/shared';
import { tableQueryParams } from 'state/table/selectors';

// Component Definition
const DistrictsNew = (): JSX.Element => {
  const districtsParams = useSelector(tableQueryParams('admin_portals'));

  return (
    <>
      <Box mb={2}>
        <BackToButton
          context="All Admin Portals"
          navigateTo={`/admin_portals${districtsParams}`}
        />
      </Box>

      <Subtitle>
        Create an Admin Portal
      </Subtitle>

      <EnhancedCard
        sx={{
          marginTop: 2,
          padding: 2,
        }}
      >
        <Typography>Coming soon...</Typography>
      </EnhancedCard>
    </>
  );
};

export default DistrictsNew;
